import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Sources from "@/pages/Sources";
import Buyers from "@/pages/Buyers";
import Runs from "@/pages/Runs";
import Exports from "@/pages/Exports";
import AiFilter from "@/pages/AiFilter";

const Shell = () => (
  <div className="min-h-screen bg-white">
    <Sidebar />
    <div className="ml-60">
      <Topbar />
      <main>
        <Outlet />
      </main>
    </div>
    <Toaster position="top-right" richColors />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Shell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/opportunities/:id" element={<OpportunityDetail />} />
              <Route path="/sources" element={<Sources />} />
              <Route path="/buyers" element={<Buyers />} />
              <Route path="/runs" element={<Runs />} />
              <Route path="/exports" element={<Exports />} />
              <Route path="/ai-filter" element={<AiFilter />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
